import { posthog, posthogLoaded } from "@/lib/posthog";

import { CITIES } from "@/seo/shared";

/** Evento de PostHog si la analítica está cargada (depende del consentimiento).
 *  Las fichas mandan `page_type` ("movie", "cinema", "city", "cartelera") y
 *  `city` para medir qué convierte el tráfico de búsqueda: sesión o entradas
 *  (ticketing_click), cine (cinema_click), película (movie_click) y
 *  suscripción (waitlist_cta_click, vía openWaitlist). */
export function track(event: string, props: Record<string, unknown> = {}) {
  if (posthogLoaded()) posthog().capture(event, props);
}

export type PageType =
  | "home"
  | "city"
  | "movie"
  | "cartelera"
  | "cinemas"
  | "cinema"
  | "subscription"
  | "legal"
  | "login"
  | "other";

/** Tipo de página por ruta, para que TODOS los $pageview lleven `page_type`
 *  y `city` y el embudo ficha → waitlist_cta_click → waitlist_signup se pueda
 *  leer en PostHog sin filtrar por URL (28-10-2026). */
export function pageTypeFor(pathname: string): { page_type: PageType; city: string | null } {
  const parts = pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  const cityDef = parts[0] ? CITIES.find((c) => c.slug === parts[0]) : undefined;
  const city = cityDef?.name ?? null;
  if (parts.length === 0) return { page_type: "home", city: null };
  if (cityDef && parts.length === 1) return { page_type: "city", city };
  if (cityDef && parts[1] === "pelicula") return { page_type: "movie", city };
  switch (parts[0]) {
    case "peliculas":
      return { page_type: parts.length === 1 ? "cartelera" : "movie", city: null };
    case "cines":
      return { page_type: parts.length === 1 ? "cinemas" : "cinema", city: null };
    case "suscripcion":
      return { page_type: "subscription", city: null };
    case "privacidad":
    case "cookies":
    case "aviso-legal":
    case "terminos":
      return { page_type: "legal", city: null };
    case "login":
      return { page_type: "login", city: null };
    default:
      return { page_type: "other", city: null };
  }
}
